import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const BlogAuthor = ({
    author
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Stack
                direction='row'
                justifyContent='start'
                alignItems='center'
                spacing={2}
                py={{xs: 2, md: 5}}
            >
                <Box
                    sx={{
                        width: {xs: 50, md: 80}
                    }}
                >
                    <img 
                        src={author.image}
                        alt={author.name} 
                        width='100%'
                        style={{
                            borderRadius: '50%',
                            aspectRatio: 1/1
                        }}
                    />
                </Box>

                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='start'
                    spacing={{xs: 0, md: 0.5}}
                >
                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 12, md: 14, lg: 16}}
                        textAlign='left'
                        color={theme.palette.text.primary}
                        lineHeight={1.25}
                    >
                        {author.name}
                    </Typography>

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, md: 12, lg: 12}}
                        textAlign="left"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                    >
                        {author.role}
                    </Typography>

                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 12, md: 12, lg: 12}}
                        textAlign="left"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                    >
                        {t('company')}
                    </Typography>
                </Stack>
            </Stack>
        </>
    );
}

export default BlogAuthor;